<template>
  <div class="max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
    <a :href="link">
      <img class="rounded-t-lg" :src="imagesrc" alt="Car Image" />
    </a>
    <div class="p-5">
      <a :href="link">
        <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
          {{ title }}
        </h5>
      </a>
      <p class="mb-3 font-bold text-gray-700 dark:text-gray-400">
        {{ sale }}
      </p>
      <p class="mb-3 font-bold text-gray-700 dark:text-gray-400">
        {{ formatNumber(price) }} ISK
      </p>

      <!-- Attributes List -->
      <ul class="flex flex-col mb-3 font-normal text-sm text-gray-700 dark:text-gray-400 list-disc list-inside">
        <li v-for="(attribute, index) in parsedAttributes" :key="index">
          {{ attribute }}
        </li>
      </ul>

      <a 
        :href="link" 
        class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      >
        Read more
        <svg 
          class="rtl:rotate-180 w-3.5 h-3.5 ms-2" 
          aria-hidden="true" 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 14 10"
        >
          <path 
            stroke="currentColor" 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            stroke-width="2" 
            d="M1 5h12m0 0L9 1m4 4L9 9"
          />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    imagesrc: {
      type: String,
      required: true,
    },
    sale: {
      type: String,
      required: false,
      default: "",
    },
    price: {
      type: Number,
      required: false,
      default: 0,
    },
    link: {
      type: String,
      required: false,
      default: "",
    },
    attributes: {
      type: String, // Accept attributes as a string
      required: false,
      default: "",
    },
  },
  computed: {
    parsedAttributes() {
      // Remove the leading [' and trailing '] and split the string into an array
      return this.attributes
        .replace(/^\['|']$/g, "") // Remove [' at the start and '] at the end
        .split(/',\s*'/) // Split by ', optionally followed by a space
        .map((attr) => attr.trim()); // Trim any remaining spaces
    },
  },
  methods: {
    formatNumber(num) {
      return parseInt(num).toLocaleString("de-DE");
    },
  },
};
</script>
